import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

export const getRequestUrl = createServerFn().handler(() => {
	return getRequest().url;
});
